export default __webpack_public_path__ + "static/tooltip-interactive-2-dont-dark-1b5fad0fa4cbd6e314e1b98193a0e75c.png";